<template>
  <div class="d-flex flex-column gap-small">
    <div
      v-for="provider in providers"
      :key="provider"
      class="d-flex flex-v-center gap-regular pd-small radius-small cursor-pointer transition-ease-in-out"
      :class="modelValue === provider ? 'bg-main bg-main-transp-10 br-1px br-main' : 'bg-light hover-bg-light'"
      @click="$emit('update:modelValue', provider)"
    >
      <div class="d-flex flex-v-center flex-justify-center w-2r h-2r radius-small bg-white">
        <span class="p-medium">{{ providerIcons[provider] || '💳' }}</span>
      </div>
      <div class="flex-child-1">
        <p class="p-regular fw-medium">{{ providerLabels[provider] || provider }}</p>
      </div>
      <div
        class="w-1r h-1r radius-round br-1px"
        :class="modelValue === provider ? 'bg-main br-main' : 'br-grey'"
      />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  providers: { type: Array, default: () => [] },
  modelValue: { type: String, default: null },
});

defineEmits(['update:modelValue']);

const { t } = useI18n();

const providerLabels = {
  yookassa: 'Банковская карта',
  stripe: 'Stripe',
  wallet: 'Кошелёк',
};

const providerIcons = {
  yookassa: '💳',
  stripe: '💳',
  wallet: '👛',
};
</script>
